import React from 'react';
import "./MailboxEmpty.css";
import MailboxIcon from "../../../media/images/MailboxIcon.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";

const G = window.glob;

const MailboxEmpty = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('MailboxEmpty');
	}
	render() {
		return(
			<div className={"MailboxEmpty"} id={this.uid}>
				<div>
					<MailboxIcon />
					<h3>
						<TextLabel value={"No Emails"} />
					</h3>
				</div>
			</div>
		);
	}
}

export default MailboxEmpty;